import MathZoo from "../games/MathZoo";

/**
 * 數學動物園遊戲頁面
 * 可以直接作為路由組件使用
 */
const MathZooPage = () => {
  return <MathZoo />;
};

export default MathZooPage;
